import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { ThreeDots } from 'react-loader-spinner';
import classNames from 'classnames';

import { useCurrentUser } from '../../../hooks/useCurrentUser';
import { useGetCurrentUserQuery } from '../../../redux/apis/userApi';
import { UserAvatar } from '../../UserAvatar/UserAvatar';

import styles from './YourInfoSection.module.scss';

export const YourInfoSection = ({ personalInfo, setCurrentStep, isEditable = true }) => {
  const { t } = useTranslation('common');
  const { isAuthenticated } = useCurrentUser();
  const { isFetching } = useGetCurrentUserQuery(undefined, { skip: !isAuthenticated });

  useEffect(() => {
    if (!isAuthenticated && !personalInfo) {
      setCurrentStep(1);
    }
  }, [isAuthenticated, personalInfo, setCurrentStep]);

  return (
    <div className={classNames('space-y-1.5')}>
      <p className={styles.yourInfoLabel}>{t('referral:yourInfo')}</p>
      <div className={classNames(styles.yourInfoContainer, { [styles.yourInfoDisabled]: isAuthenticated })}>
        {isFetching ? (
          <ThreeDots height="20" width="32" radius="9" color="#314155" ariaLabel="three-dots-loading" visible />
        ) : (
          <>
            <p className={styles.yourInfoValue}>
              <UserAvatar imageUrl={personalInfo?.avatar_thumb} name={personalInfo?.firstName} />
              <span>{`${personalInfo?.firstName} ${personalInfo?.lastName}`}</span>
              <span className={styles.yourInfoValueEmail}>{personalInfo?.email}</span>
            </p>
            {!isAuthenticated && isEditable && setCurrentStep && (
              <button className={styles.editButton} type="button" onClick={() => setCurrentStep(1)}>
                {t('edit')}
              </button>
            )}
          </>
        )}
      </div>
    </div>
  );
};
